import React, { ReactElement } from 'react';
import { ReactComponent as BlankSVG } from './Blank.svg';

export function DefaultIntegrationIcon(): ReactElement {
  return <BlankSVG />;
}
